<template>
    <div class="sm:max-w-4xl mx-auto">
        <resource-index title="Активность" :endpoint="endpoint">
            <template v-slot:table-header>
                <tr class="border-b">
                    <th class="text-left p-3 px-5" scope="col">Пользователь</th>
                    <th class="text-left p-3 px-5" scope="col">Изменения</th>
                    <th class="text-left p-3 px-5" scope="col">Дата</th>
                </tr>
            </template>

            <template v-slot:row="slotProps">
                <td class="p-3 px-5">{{ slotProps.entry.causer.full_name }}</td>

                <td class="p-3 px-5 text-sm">
                    <div
                        v-if="slotProps.entry.description == 'added'"
                    >Добавлено – {{ slotProps.entry.properties.quantity }} шт.</div>
                    <div
                        v-else
                        v-for="(newValue, attribute) in slotProps.entry.properties.attributes"
                        :key="attribute"
                    >{{ getAttributeLabel(attribute) }} – {{ getAttributeValueLabel(attribute, newValue) }} ({{ getAttributeValueLabel(attribute, slotProps.entry.properties.old[attribute]) }})</div>
                </td>

                <td class="p-3 px-5">
                    <span
                        class="badge whitespace-no-wrap badge-indigo"
                    >{{ localTime(slotProps.entry.created_at) }}</span>
                </td>
            </template>
        </resource-index>
    </div>
</template>

<script>
import ResourceIndex from "@/components/Resource/ResourceIndex";

export default {
    components: {
        ResourceIndex
    },

    props: {
        modelType: String,
        modelId: Number,
        attributes: Object
    },

    data() {
        return {
            endpoint: `admin/activities/${this.modelType}/${this.modelId}`
        };
    },

    methods: {
        getAttributeLabel(attributeName) {
            if (this.attributes[attributeName]) {
                return this.attributes[attributeName].label;
            }

            return attributeName;
        },

        getAttributeValueLabel(attributeName, valueName) {
            if (this.attributes[attributeName]) {
                if (this.attributes[attributeName].values) {
                    if (this.attributes[attributeName].values[valueName]) {
                        return this.attributes[attributeName].values[valueName];
                    }
                }
            }

            return valueName;
        }
    }
};
</script>